export default {
    viewlogies: 'Viewlogies',
    viewlogiesAllCaps: 'VIEWLOGIES',
    phoneNumber: '(415) 763-8439',
    supportEmail: 'support@viewlogies.com',
    pronounced: 'pronounced: /v • eulogies/',
    copyright: 'Copyright © 2025 Viewlogies. All rights reserved.',
    errorIntro: 'There was an error',
};
